

<template>
  <div>
    <!--    Breadcrumb Section Component-->
    <breadcrumb :breadcrumb="breadcrumb"/>
    <!--    Products Section Component-->
    <products-area/>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import ProductsArea from "../components/products/ProductsArea";

export default {
  name: 'Products',
  components: {ProductsArea, Breadcrumb},
  data() {
    return {
      breadcrumb: {
        title: 'Products',
        link: 'Products'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Products.vue